export const PARAMETER_DATA_TYPES = {
  NUMBER: 0,
  STRING: 1,
  TIME: 2,
  DATETIME: 3,
  BOOLEAN: 4,
  JSON: 5,
  TEMPLATE: 6,
}; // Parameter Data Types, in this order, are defined in models.py. 

/* SYNC CONSTANTS 
  Constants for Sync and MQTT calls.
  Values below should match the values in 'mdm-backend/commonlib/lib/constants'
*/
export const SYNC_COMMANDS = {
  HELLO: 1,
  APPINFO: 130,
  SYSAPPINFO: 230,
  PARAMINFO: 120,
  SENDDATA: 3,
  SYSTEM: 4,
  RUNCOMMAND: 5
};

export const SYNC_TYPES = {
  SYNC: 11,
  UPDATE: 12,
  SCHEDULE: 13,
  TELEMETRY: 300,
  SALESREPORTS: 301,
  OWNERCHANGED: 400,
  CLICOMMAND: 500
};

// Outcome codes of the protocol log rows (SyncLog / ApiLog `status`). Both
// protocols speak the same vocabulary — the sync envelope's `response` and the
// api envelope's `code` are 0 = success, -1 = error (backend
// sync/views/constants.py Response and api/views/constants.py Code). Shaped as
// `{key, value}` for ComplexFilterRow's `choices` input.
export const PROTOCOL_STATUS_CHOICES = [
  { key: 'Success', value: 0 },
  { key: 'Error', value: -1 },
];

export const HELLO_DATA_TYPES = {
  APPINFO: 130,
  SYSAPPINFO: 230,
  PARAMINFO: 120,
  ALL: 100
}

export const APPLICATION_PACKAGE_TYPES = {
  APK: 10,
  OTA: 20
}

export const CONSUMABLE_STATES = {
  NOT_DELIVERED: "0",
  DELIVERED: "1",
}

export const INCIDENT_STATES = {
  WAITING_FOR_APPROVAL: "0",
  IN_PROGRESS: "1",
  RESOLVED: "2",
  REJECTED: "3"
} // Incident Status values, in this order, are defined in enumerations.py.

export const BANK_DEVICE_STATES = {
  REGISTERED: "0",
  ASSIGNED_TO_MERCHANT : "1",
  READY_TO_BE_INSTALLED: "2",
  INSTALLED_AND_READY_FOR_PAYMENT: "3",
  CONTRACT_CANCELLED: "4",
}

export const BANK_DEVICE_STATES_REVERSE = {
  0: "Registered",
  1 : "Assigned To Merchant",
  2: "Ready To Be Installed",
  3: "Installed and Ready For Payment",
  4: "Contract Cancelled",
}

export const SLA_STATES = {
  IN_PROGRESS: "0",
  ACHIEVED: "1",
  DELAYED: "2",
  NOT_TRACKED: "3"
} // SLA Status values, in this order, are defined in enumerations.py.
